import { render, staticRenderFns } from "./SingleColorPlanetSlide.vue?vue&type=template&id=94bd5a80&scoped=true"
import script from "./SingleColorPlanetSlide.vue?vue&type=script&lang=js"
export * from "./SingleColorPlanetSlide.vue?vue&type=script&lang=js"
import style0 from "./SingleColorPlanetSlide.vue?vue&type=style&index=0&id=94bd5a80&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bd5a80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94bd5a80')) {
      api.createRecord('94bd5a80', component.options)
    } else {
      api.reload('94bd5a80', component.options)
    }
    module.hot.accept("./SingleColorPlanetSlide.vue?vue&type=template&id=94bd5a80&scoped=true", function () {
      api.rerender('94bd5a80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/slides/SingleColorPlanetSlide.vue"
export default component.exports